'use strict';

exceptionService.$inject = ["gettextCatalog"];
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.exceptionService = exceptionService;
/*@ngInject*/
function exceptionService(gettextCatalog) {
    return {
        logException: logException
    };

    function logException(msg) {
        var title = gettextCatalog.getString('Error');
        'error', title, msg;
    }
}


//////////////////
// WEBPACK FOOTER
// ./common/services/exceptionService.js
// module id = 812
// module chunks = 0